import { AppContext } from 'types/types';
import { createAction } from 'typesafe-actions';

import { Pin, PinNew, PinNewWithName, Plan, PlanLoaded } from './types';

export type PlanPinSearch = {
  id: string;
};

export const doLoadPlans = createAction('@doLoadPlans')<
  {
    context: AppContext;
    plansEditable: boolean;
    findNoun?: string;
    actionAfterFind?: {
      type: string;
      payload: PlanPinSearch & Record<string, unknown>;
    };
    selectionKey?: string;
    plans: Record<string, Plan>;
    pin?: undefined | PinNew;
    pins: PinNewWithName[];
  } & (
    | { planId?: undefined; pinId?: undefined }
    | { planId: string; pinId?: undefined }
    | { planId?: undefined; pinId: string }
  )
>();

export const doClosePlans = createAction('@doClosePlans')();

export const doPlansUsePin = createAction('@doPlansUsePin')();

export const doUnloadPlans = createAction('@doUnloadPlans')();

export const doPlansCreatePlan = createAction('@doPlansCreatePlan')<{
  id: string;
  name: string;
  fileId: string;
}>();

export const doPlansUpdatePlan = createAction('@doPlansUpdatePlan')<{
  name: string;
}>();

export const doPlansDeletePlan = createAction('@doPlansDeletePlan')<{
  id: string;
}>();

export const doPlansLoadPlan = createAction('@doPlansLoadPlan')<{
  id: string;
}>();

export const doPlansSetPlan = createAction('@doPlansSetPlan')<{
  plan: PlanLoaded | undefined;
}>();

export const doPlansSetSelectedPinId = createAction('@doPlansSetSelectedPinId')<
  string | undefined
>();

export const doPlansUpdatePin = createAction('@doPlansUpdatePin')<{
  planId: PinNew['planId'];
  x: PinNew['x'];
  y: PinNew['y'];
  name?: Pin['name'];
}>();

export const doPlanUnsetPin = createAction('@PLAN/doPlanUnsetPin')();
